import { Component, OnInit, inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import {Article} from '@app/article/shared/article';
import {ArticleApi} from '@app/article/shared/article.api';
import {RelationArticle} from '../shared/relation-article';
import {RelationArticleApi} from '../shared/relation-article.api';
import {RelationArticleGroupApi} from '../shared/relation-article-group.api';
import {RelationArticleGroup} from '../shared/relation-article-group';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { MatCard, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatToolbar } from '@angular/material/toolbar';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTooltip } from '@angular/material/tooltip';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';

@Component({
    templateUrl: 'relation-article-dialog.component.html',
    styleUrls: ['relation-article-dialog.component.scss'],
    imports: [MatCard, ReactiveFormsModule, MatToolbar, MatSlideToggle, MatTooltip, MatCardContent, MatFormField, MatLabel, MatSelect, MatOption, MatInput, MatCardActions, MatButton]
})
export class RelationArticleDialogComponent implements OnInit {
  private articleApi = inject(ArticleApi);
  private relationArticleApi = inject(RelationArticleApi);
  private relationArticleGroupApi = inject(RelationArticleGroupApi);
  private formBuilder = inject(UntypedFormBuilder);
  dialogRef = inject<MatDialogRef<RelationArticleDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  articles: Article[];
  editForm: UntypedFormGroup;
  groups: RelationArticleGroup[];
  relationArticle: RelationArticle;

  constructor() {
    const data = this.data;

    if (data?.relationArticle) {
      this.relationArticle = data.relationArticle;
    }

    this.articleApi.findAll().subscribe(value => {
      this.articles = value;
    });

    this.relationArticleGroupApi.findAll().subscribe(value => {
      this.groups = value;
    });


    this.createForm();


  }

  ngOnInit(): void {
    if (this.relationArticle) {
      this.editForm.patchValue(this.relationArticle);
    }
  }

  createForm() {
    this.editForm = this.formBuilder.group({
      number: null,
      groupId: null,
      groupName: null,
      articleNumber: null,
      relationNumber: null,
      name: null,
      active: null
    });
  }


  onSave() {
    if (!this.relationArticle.number) {
      this.relationArticleApi.save(this.editForm.value).subscribe(() => {
        this.dialogRef.close(true);
      });
    } else {
      this.relationArticleApi.update(this.editForm.value).subscribe(() => {
        this.dialogRef.close(true);
      });
    }
  }

  onCancel() {
    this.dialogRef.close(false);
  }
}
